import { types, actions, Action } from '.';
import { SagaIterator } from 'redux-saga';
import { put, takeLatest, call } from 'redux-saga/effects';
import { AgreeTermsResponse } from 'src/models/agreeTerms';
import * as agreeTermsApi from '../../../api/agreeTerms';
import { actions as workflowActions } from '../../entities/workflow';
import { actions as appUIActions } from '../../uis/app';
import { rollbar } from 'src';

export default function* watchAgreeTermsData(): SagaIterator {
    yield takeLatest(types.SUBMIT_AGREE_TERMS_ASYNC, submitAgreeTermsAsync);
}

export function* submitAgreeTermsAsync(action: Action): SagaIterator {
    try {
        yield put(actions.actionServerDataRequested());

        const response: AgreeTermsResponse = yield call(agreeTermsApi.submitAgreeTerms, action.agreeTerms);

        if (response.termsAgreed) {
            yield put(actions.submitAgreeTermsSucceeded(response.termsAgreed));
            yield put(workflowActions.storeWorkflowData(response.workflow));
            yield put(appUIActions.setMessageIndicator('Submit agree terms successfully, go to the step 04', 'success'));
        } else {
            yield put(actions.actionServerDataFailed());
            yield put(appUIActions.setMessageIndicator('Submit agree terms have not been agreed!', 'error'));
            yield call(console.log, 'Submit agree terms have not been agreed!');
        }
    } catch (e) {
        console.log(e);
        rollbar.error('Cannot submit confirm identity answers!');
        yield put(actions.actionServerDataFailed());
        yield put(appUIActions.setMessageIndicator('Submit agree terms failed!', 'error'));
        yield call(console.log, 'Cannot submit confirm identity answers!');
    }
}


// WEBPACK FOOTER //
// ./src/modules/entities/agreeTerms/saga.ts